/**
 * "Hold on there coach." — the prompt a player meets when they try to leave a
 * match they still owe a score for (BK, 28 Jul).
 *
 * There is ONE button and it goes forward. No dismiss, no "later": the whole
 * point is that the result gets filed, and an escape hatch here would make the
 * lock decorative. Tapping outside closes the sheet, which returns them to the
 * match — not out of it — so nobody is stuck staring at a modal they cannot
 * interact with, and nobody gets past it either.
 */
import { RESULT_LOCK_TITLE, lockBody, lockCta, type LockKind } from "../../lib/resultLock";

export interface ResultLockSheetProps {
  open: boolean;
  /** Which obligation is being held — owing your score, or owing a verdict on
   *  theirs. The sheet must not tell a player to "submit your result" when the
   *  result is already in and what is wanted is their word on it. */
  kind: LockKind;
  /** Back to the match, sheet closed — they are already where they need to be. */
  onDismiss: () => void;
  /** Straight to the scoreboard. */
  onSubmit: () => void;
}

export function ResultLockSheet({ open, kind, onDismiss, onSubmit }: ResultLockSheetProps) {
  if (!open) return null;
  return (
    <div className="rl-scrim" role="dialog" aria-modal="true" aria-label={RESULT_LOCK_TITLE} onClick={onDismiss}>
      <div className="rl-sheet" onClick={(e) => e.stopPropagation()}>
        <h2 className="rl-title">{RESULT_LOCK_TITLE}</h2>
        <p className="rl-body">{lockBody(kind)}</p>
        <button type="button" className="rl-cta" onClick={onSubmit}>
          {lockCta(kind)}
        </button>
      </div>
    </div>
  );
}
